/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "speed--sprite",
  "use": "speed--sprite-usage",
  "viewBox": "0 0 32 27",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 27\" id=\"speed--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.179 2.5C8.634 2.5 2.518 8.54 2.518 15.99a13.34 13.34 0 0 0 3.28 8.772.743.743 0 0 1-.082 1.057.766.766 0 0 1-1.07-.082A14.827 14.827 0 0 1 1 15.991C1 7.711 7.796 1 16.179 1c8.382 0 15.178 6.712 15.178 14.991 0 3.72-1.373 7.127-3.646 9.747a.766.766 0 0 1-1.07.082.743.743 0 0 1-.083-1.057 13.34 13.34 0 0 0 3.281-8.772C29.84 8.54 23.723 2.5 16.18 2.5Zm0 3.747c-5.45 0-9.866 4.363-9.866 9.744 0 2.561.999 4.89 2.635 6.63a.743.743 0 0 1-.04 1.06.766.766 0 0 1-1.072-.04 11.132 11.132 0 0 1-3.041-7.65c0-6.21 5.096-11.243 11.384-11.243 5.158 0 9.513 3.387 10.912 8.031a.748.748 0 0 1-.511.932.76.76 0 0 1-.944-.504c-1.213-4.026-4.99-6.96-9.457-6.96ZM27.917 16.55a.75.75 0 0 1-.541.916l-7.419 1.925c.01.115.016.23.016.348 0 2.07-1.699 3.748-3.794 3.748-2.096 0-3.795-1.678-3.795-3.748 0-2.07 1.699-3.748 3.795-3.748a3.8 3.8 0 0 1 3.338 1.965l7.473-1.94a.76.76 0 0 1 .927.534Zm-9.603 2.407a2.276 2.276 0 0 0-2.135-1.467c-1.258 0-2.277 1.007-2.277 2.249 0 1.242 1.02 2.249 2.277 2.249 1.257 0 2.276-1.007 2.276-2.25 0-.192-.024-.379-.07-.557a.735.735 0 0 1-.071-.224Z\" fill=\"#232323\" stroke=\"#fff\" stroke-width=\".1\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
